export const itemsByTabDefaults = {
    contratos: [],
    produtos: [],
    servicos: [],
}

export const paymentTabs = [
    { key: "dinheiro", label: "Dinheiro" },
    { key: "pix", label: "Pix" },
    { key: "transferencia", label: "Transferência" },
    { key: "debito", label: "Cartão de débito" },
    { key: "credito", label: "Cartão de crédito" },
]
